module.exports = __webpack_public_path__ + "static/media/ic_amex.a5544941.svg";